import { useRoutes } from 'react-router-dom';
import { CasAuthenticationHOC } from 'src/compass/site/components';
import Page401 from 'src/compass/pages/error/Page401';
import Page404 from 'src/compass/pages/error/Page404';
import Page500 from 'src/compass/pages/error/Page500';
import Page503 from 'src/compass/pages/error/Page503';
import LogoutPage from 'src/compass/pages/authentication/LogoutPage';
import { useMenuRoutes, paths } from 'src/compass/site/routes';
import HomePage from 'src/compass/pages/home/HomePage';
import PublicLrpQuotesPage from 'src/compass/pages/public/PublicLrpQuotesPage';
import { useCasAuthenticated } from 'src/compass/shared/hooks/useCasAuthenticated';
import PublicUploadFilesPage from 'src/compass/pages/public/PublicUploadFilesPage';
import PublicLayoutInfoPage from 'src/compass/pages/public/PublicLayoutInfoPage';

const publicRoutes = [
  {
    path: '/lrp-quotes',
    element: <PublicLrpQuotesPage />
  },
  {
    path: '/upload',
    element: <PublicUploadFilesPage />
  },
  {
    path: '/public/layoutInfo',
    element: <PublicLayoutInfoPage />
  },
];

export default function CasRouter() {
  const menuRoutes = useMenuRoutes();
  const {isAuthenticated, isWebuser} = useCasAuthenticated();

  // not logged  in case
  if (!isAuthenticated
  || isWebuser) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useRoutes([
      ...publicRoutes,
      {
        path: '*',
        element: CasAuthenticationHOC({
          Component: <HomePage />,
        }),
      },
    ]);
  }

  const routing: any = [
    ...publicRoutes,
    ...menuRoutes,
    {
      path: paths.logoutPage,
      element: <LogoutPage />
    },
    {
      path: paths.page401,
      element: <Page401 />,
    },
    {
      path: paths.page503,
      element: <Page503 />,
    },
    { path: paths.page500, element: <Page500 /> },
    { path: '*', element: <Page404 /> },
  ];

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useRoutes(routing);
}
